module.exports = new __parcel__URL__("model-location-icon.30f78d82.png").toString();